import { render, staticRenderFns } from "./PriorityDropdown.vue?vue&type=template&id=63e526bf&scoped=true&"
import script from "./PriorityDropdown.vue?vue&type=script&lang=js&"
export * from "./PriorityDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e526bf",
  null
  
)

export default component.exports